import { memoize } from "decko";

export default class MongoDb {
  @memoize
  static checkIsMongoId(string) {
    return /^[a-f\d]{24}$/i.test(string);
  }
}
